import { render, staticRenderFns } from "./ConfigLink.vue?vue&type=template&id=59e850c4"
import script from "./ConfigLink.vue?vue&type=script&lang=js"
export * from "./ConfigLink.vue?vue&type=script&lang=js"
import style0 from "./ConfigLink.vue?vue&type=style&index=0&id=59e850c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports